import { IRes } from '@/types'
import { getApiRequest } from '@/utils'

const request = getApiRequest()
export function uploadFileService(data: FormData) {
  return request.post<IRes<string | null>>('/design/export/uploadTopologyFile', data)
}
